


































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import SectionBase from '@/mixins/SectionBase'
import OrderSectionBase from './OrderSectionBase'
import { colorNames, getColorWarnings } from '@/data/colors'
import { cavettoOptions, getCavettoHelpText } from '@/data/cavetto'

@Component({
  mixins: [SectionBase, OrderSectionBase],
})
export default class SectionCorian extends OrderSectionBase {
  colors: string[] = colorNames;
  cavettoOptions = cavettoOptions;

  get colorWarnings(): string[] {
    var color = this.value('corian_color');
    if (typeof(color) !== 'string') {
      throw new Error("Color field must be a string")
    }

    return getColorWarnings(color)
  }

  get cavettoHelpText(): string | null {
    var cavetto = this.value('cavetto');
    if (typeof(cavetto) !== 'string') {
      throw new Error("Cavetto field must be a string")
    }

    return getCavettoHelpText(cavetto)
  }

  get thicknessRequirement(): string {
    const cooktop = this.value('cooktop_mounting');
    if (cooktop === 'level_glued') {
      return 'required|numeric|min_value:24';
    } else {
      return 'required|numeric|min_value:12';
    }
  }
}
